import User from "manifest-components/src/classes/user";
import UserDetails from "manifest-components/src/classes/userDetails";
import { envVariables } from "../env";

export const generateZohoBookingIframe = ({
  user,
  transferInstructionId,
  userDetails,
}: {
  user: User;
  userDetails: UserDetails;
  transferInstructionId: string | number;
}) => {
  const zohoBookingUrl = envVariables.REACT_APP_ZOHO_BOOKING_URL;
  const iframe = document.createElement("iframe");
  iframe.src = `${zohoBookingUrl}?Name=${userDetails.firstName} ${userDetails.lastName}&Email=${user.email}&Contact Number=${user.phone}&transferInstructionId=${transferInstructionId}&userId=${user.userId}`;
  iframe.style.border = "none";
  iframe.id = "zoho-booking-id";
  return iframe;
};
